var _text;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgParagraphField(props, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 10,
    height: 14,
    ref: svgRef
  }, props), _text || (_text = /*#__PURE__*/React.createElement("text", {
    fill: "#595959",
    fillRule: "evenodd",
    fontFamily: "Rockwell-Regular, Rockwell",
    fontSize: 15
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 4,
    y: 10
  }, "T"))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgParagraphField);
export default __webpack_public_path__ + "static/media/paragraph-field.d348da8b.svg";
export { ForwardRef as ReactComponent };